export {
  faAddressCard,
  faArchive,
  faArrowDownShortWide,
  faArrowsH,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faArrowRotateLeft,
  faArrowRight,
  faArrowUpWideShort,
  faCube,
  faClipboardCheck,
  faClock,
  faBan,
  faBars,
  faBell,
  faBellOn,
  faBook,
  faBox,
  faBoxArchive,
  faBoxOpen,
  faBuilding,
  faBracketsCurly,
  faCalculator,
  faCalendarAlt,
  faCalendarLinesPen,
  faCalendarPlus,
  faCalendarRange,
  faCar,
  faCarBurst,
  faCartShoppingFast,
  faChartBar,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleNotch,
  faCircleMinus,
  faCircleXmark,
  faCommentDots,
  faCode,
  faCog,
  faCommentAltCheck,
  faCopy,
  faCrown,
  faDownload,
  faEdit,
  faEllipsisVertical,
  faEnvelope,
  faExclamation,
  faExclamationCircle,
  faExchangeAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowUp,
  faFileArrowDown,
  faFileCircleCheck,
  faFileCircleXmark,
  faFileContract,
  faFileCheck,
  faFileCsv,
  faFileDoc,
  faFileMagnifyingGlass,
  faFileEps,
  faFileExport,
  faFileImport,
  faFileLines,
  faFilePdf,
  faFilePen,
  faFiles,
  faFileSignature,
  faFileText,
  faFilter,
  faFileUpload,
  faFileXls,
  faFileXmark,
  faFloppyDisk,
  faFloppyDiskPen,
  faGauge,
  faGaugeMax,
  faGaugeMin,
  faGlobe,
  faGlobePointer,
  faGrid,
  faHandshakeSimple,
  faImage,
  faInboxIn,
  faInfo,
  faInfoCircle,
  faLandmark,
  faLandmarkMagnifyingGlass,
  faLock,
  faList,
  faLink,
  faMapLocationDot,
  faMapMarkerAlt,
  faMessageLines,
  faMemo,
  faMemoCircleCheck,
  faMinus,
  faMoneyBillTrendUp,
  faMoneyCheckDollarPen,
  faNoteSticky,
  faPaperclip,
  faPaperPlane,
  faPen,
  faPenSlash,
  faPenToSquare,
  faPhone,
  faPhoneFlip,
  faPhoneOffice,
  faPhoneVolume,
  faPlus,
  faPlusSquare,
  faRectangleHistoryCircleUser,
  faRecycle,
  faRightFromBracket,
  faRotateLeft,
  faScrewdriverWrench,
  faSearch,
  faShoppingCart,
  faSignOut,
  faSitemap,
  faSparkles,
  faSquareUpRight,
  faSquareCode,
  faTable,
  faTachometerAltFastest,
  faTimeline,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faTriangleExclamation,
  faToolbox,
  faUnlink,
  faUser,
  faUserCheck,
  faUserGroup,
  faUserHeadset,
  faUserPlus,
  faUserRobot,
  faUserPen,
  faUsers,
  faUserSecret,
  faUserTie,
  faUnlockAlt,
  faWrench,
  faListCheck,
  faStickyNote,
  faFileAlt,
  faQuestionCircle,
  faFileCirclePlus,
  faShieldCheck,
  faShield,
  faXmark,
  faGlasses,
} from '@fortawesome/pro-regular-svg-icons';
